"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
const react_1 = require("react");
const AlertContext_1 = require("./AlertContext");
const useAlert = () => {
    const { dispatch } = react_1.useContext(AlertContext_1.AlertContext);
    const alert = ({ buttons = [], hideBackButton = false, severity = 'error', message = '', notClosableByOutsidePress = false, title = 'هشدار', }) => {
        dispatch({
            type: 'set_alert_buttons',
            payload: buttons,
        });
        dispatch({
            type: 'set_alert_hide_back_button',
            payload: hideBackButton,
        });
        dispatch({
            type: 'set_alert_message',
            payload: message,
        });
        dispatch({
            type: 'set_alert_not_closable_by_outside_press',
            payload: notClosableByOutsidePress,
        });
        dispatch({
            type: 'set_alert_title',
            payload: title,
        });
        dispatch({
            type: 'set_alert_severity',
            payload: severity,
        });
        dispatch({
            type: 'set_alert_visible',
            payload: true,
        });
    };
    return alert;
};
exports.useAlert = useAlert;
